import {
    FETCH_PLAN_SUBOPTION_LOOKUP_REQUEST,
    FETCH_PLAN_SUBOPTION_LOOKUP_SUCCESS,
    FETCH_PLAN_SUBOPTION_LOOKUP_FAILURE,
  } from "./FetchPlanSubOptionLookupTypes";
  
  const initialState = {
    loading: false,
    planSubOptionLookup: [],
    error: "",
  };
  
  const reducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_PLAN_SUBOPTION_LOOKUP_REQUEST:
        return {
          ...state,
          loading: true,
        };
      case FETCH_PLAN_SUBOPTION_LOOKUP_SUCCESS:
        return {
          loading: false,
          planSubOptionLookup: action.payload,
          error: "",
        };
      case FETCH_PLAN_SUBOPTION_LOOKUP_FAILURE:
        return {
          loading: false,
          procedureLookup: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default reducer;
  